var script_loaded=!1;
function loadJSscripts(){
  if(!script_loaded){

    script_loaded=!0;
    
    window.yett.unblock();
    

    //window.YETT_BLACKLIST = [/cdn\.shopify\.com\/extensions\/0ce2cf37-45df-40a1-bc3b-f18a7878d020\/2\.3\.0\/assets\/stickycart-v2\.js$/];  

    var q=document.getElementsByTagName("script");
    for(i=0;i<q.length;i++) null!==q[i].getAttribute("jquery-src")&&(q[i].setAttribute("src",q[i].getAttribute("jquery-src")),delete q[i].dataset.src);   

    var t=document.getElementsByTagName("link");
    for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-href")&&(t[i].setAttribute("href",t[i].getAttribute("data-href")),delete t[i].dataset.href);

    var e=document.getElementsByTagName("script");
    for(i=0;i<e.length;i++) null!==e[i].getAttribute("data-src")&&(e[i].setAttribute("src",e[i].getAttribute("data-src")),delete e[i].dataset.src);

    var t=document.getElementsByTagName("iframe");
    for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src);

    

    document.dispatchEvent(new CustomEvent("StartShopifyCoreLoading"));
    document.dispatchEvent(new CustomEvent("ShopifyAsyncLoading"));
    document.querySelectorAll('body')[0].classList.add('all-loaded');
    window.speedIndexLoaded = true;
    //console.log('UNHOLD');
    
  }
}

Shopify.designMode 
  ?loadJSscripts()
  :(
    window.addEventListener("scroll",function(e){loadJSscripts()}),
    window.addEventListener("mousemove",function(){loadJSscripts()}),
    window.addEventListener("touchstart",function(){loadJSscripts()}),
    window.addEventListener
      ?window.addEventListener("load",function(){setTimeout(loadJSscripts,4000)},!1)
      :window.attachEvent 
        ?window.attachEvent("onload",function(){setTimeout(loadJSscripts,4000)})  
        :window.onload=loadJSscripts);
  
  